import { buildModelsActionCreator } from '../actions';

export const FETCH_REQ_SLAS_MODEL = 'epic.model.FETCH_REQ_SLAS_MODEL';

export type FetchReqSlasModelAction = ReturnType<typeof fetchReqSlasModelAction>;

export const fetchReqSlasModelAction = buildModelsActionCreator(FETCH_REQ_SLAS_MODEL, 'reqSlas');
